import { render, staticRenderFns } from "./YzTextField.vue?vue&type=template&id=4890dd0c&scoped=true&lang=pug&"
import script from "./YzTextField.vue?vue&type=script&lang=js&"
export * from "./YzTextField.vue?vue&type=script&lang=js&"
import style0 from "./YzTextField.vue?vue&type=style&index=0&id=4890dd0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4890dd0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
